'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('project_prioritization', {
      url: '/account/stationaccess/project_prioritization?jurisdiction&sta_recid',
      template: '<project-prioritization></project-prioritization>',
      authenticate: true,
      params: {
        jurisdiction: null,
        sta_recid: null      
      }
    });
}



// WEBPACK FOOTER //
// ./client/app/account/stationaccess/project_prioritization/project_prioritization.routes.js